import React, { useEffect, useState } from "react";
import MarkesEvaluationTable from "../../Components/MarkesEvaluationTable";
import YesNoTable from "../../Components/yesNoTable";
import RecommendationsSection from "../../Components/RecommendationsSection";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import { useDispatch, useSelector } from "react-redux";
import { GetAllMarksBySubTaskGuid } from "../../Redux/Reducers/MarksManager";
import { GetAllYesNoListByTaskGuid } from "../../Redux/Reducers/YesNoManager";
import { useParams } from "react-router-dom";
import { GetComponentByFlow } from "../../Redux/Reducers/ComponentByFlow";
import { GetActionButtons } from "../../Redux/Reducers/ActionButtons";
import ButtonActionManager from "../ButtonActionManager";
import { GetAllSubTaskByMain } from "../../Redux/Reducers/AllSubTaskByMain";
import "./style.css";
import InputAHSF from "../../Components/InputAHSF";
import { GetHeaderTaskPageData } from "../../Redux/Reducers/HeaderTaskPageData";
export default function SubTaskSection(props) {
  const dispatch = useDispatch();

  //   let { mainTaskId } = useParams();
  //[,]
  // فك تشفير ال  param

  const state = useSelector((state) => {
    return {
      MarksManager: state.MarksManager.MarksManager,
      loadingMarksManager: state.MarksManager.loadingMarksManager,
      YesNoManagerBySubTask: state.YesNoManagerBySubTask?.YesNoManagerBySubTask,
      loadingYesNoManagerBySubTask: state.loadingYesNoManagerBySubTask,
      OneComponentByFlow: state.OneComponentByFlow,
      ActionButtons: state.ActionButtons.ActionButtons,
      loadingActionButtons: state.ActionButtons.loadingActionButtons,
      UserInfo: state.UserInfo.UserInfo,
      AllSubTaskByMain: state.AllSubTaskByMain,
      HeaderTaskPageData: state.HeaderTaskPageData.HeaderTaskPageData,
    };
  });

  //[,]
  //to get all components by flow
  useEffect(() => {
    dispatch(
      GetComponentByFlow({
        appiliacationInfo: localStorage.getItem(
          "aI_ApplicationInformationId_Manager"
        ),
        flowGUID: props.flowGUID,
      })
    );
    //[,]
    //to get all  action  buttons
    dispatch(
      GetActionButtons({
        aI_ApplicationInformationId: localStorage.getItem(
          "aI_ApplicationInformationId_Manager"
        ),
        flowGUID: props.flowGUID,
        isMainFlow: true,
      })
    );
    //[,]
    //to get application info
    dispatch(
      GetHeaderTaskPageData(
        localStorage.getItem("aI_ApplicationInformationId_Manager")
      )
    );
  }, []);
  //[,]
  // to sort component view 
  let sortedComponents = [];
  if (state.OneComponentByFlow?.OneComponentByFlow) {
    sortedComponents = [...state.OneComponentByFlow.OneComponentByFlow].sort(
      (a, b) => a.rowOrder - b.rowOrder
    );
  }

  //[,]
  //components name from backend and frontend
  const componentMap = {
    Marks: MarkesEvaluationTable,
    Recommendations: RecommendationsSection,
    YesNo: YesNoTable,
  };
  return (
    <>
      <div className="SubTaskSection">
        <div className="form-grid">
          <InputAHSF
            fieldsName="ApplicationNumberInput"
            show={true}
            disabled={true}
            value={state.HeaderTaskPageData?.applicationNumber}
          />
          <InputAHSF
            fieldsName="M_ProjectName"
            show={true}
            disabled={true}
            value={state.HeaderTaskPageData?.projectName}
          />
          <InputAHSF
            fieldsName="M_ApplicantName"
            show={true}
            disabled={true}
            value={state.HeaderTaskPageData?.applicantNem}
          />

          <InputAHSF
            fieldsName="ResponsiblePerson"
            show={true}
            disabled={true}
            value={props.ResponsiblePerson}
          />
          <InputAHSF
            fieldsName="M_subTaskName"
            show={true}
            disabled={true}
            value={props.subTaskName}
          />
          <InputAHSF
            fieldsName="M_subTaskStatus"
            show={true}
            disabled={true}
            value={props.subTaskStatus}
          />
        </div>
        {/* [,] */}
        {/* to render components by flow  */}
        {sortedComponents.map((component) => {
          const ComponentToRender =
            componentMap[component.flowComponentTypeName];

          return ComponentToRender ? (
            <ComponentToRender
              key={component.flowComponentRoundGuid}
              flowGUID={component.flowGUID}
              flowComponentName={component.flowComponentName}
              flowComponentTypeName={component.flowComponentTypeName}
              taskId={props.taskId}
              disabled={true}

            />
          ) : (
            <></>
          );
        })}
        {/* {state.ActionButtons && state.ActionButtons.length > 0 ? (
          <ButtonActionManager
            list={state.ActionButtons}
            subTaskGuid={decodeParam(taskId)}
            // taskGuid={decodeParam(mainTaskId)}
            // onUpdateActionButton={onUpdateActionButton}
          />
        ) : (
          ""
        )} */}
      </div>
    </>
  );
}
